import { useEffect, useMemo, useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import { fetchStore } from "@/lib/api";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { sfx } from "@/lib/sounds";

export default function Store() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { fetchStore().then(setItems).catch(() => {}); }, []);
  const categories = useMemo(() => ["All", ...Array.from(new Set(items.map(i => i.category)))], [items]);
  const filtered = cat === "All" ? items : items.filter(i => i.category === cat);

  return (
    <div className="pt-32 pb-24 px-4 sm:px-6" data-testid="page-store">
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Store" title="Support The Network" subtitle="Ranks, keys, cosmetics and DC Coins. Every purchase helps keep the servers running." />
        <div className="flex flex-wrap gap-2 mb-10">
          {categories.map(c => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`store-cat-${c.toLowerCase().replace(/\s/g,'-')}`}
              className={`px-4 py-2 rounded-full text-xs uppercase tracking-widest transition-colors ${
                cat === c ? "bg-[#FFBF00] text-black" : "glass hover:border-[#FFBF00]/40"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((it) => (
            <div
              key={it.id}
              data-testid={`store-item-${it.id}`}
              className={`relative rounded-2xl glass hover-lift overflow-hidden ${it.featured ? "shimmer-border" : ""}`}
            >
              {it.featured && (
                <div className="absolute top-3 right-3 z-10 flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#FFBF00] text-black text-[10px] uppercase tracking-widest font-bold">
                  <Sparkles size={12} /> Featured
                </div>
              )}
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={it.image} alt={it.name} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
                <div className="absolute bottom-3 left-3">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFBF00]/90">{it.category}</div>
                  <div className="font-hero text-2xl">{it.name}</div>
                </div>
              </div>
              <div className="p-5">
                <ul className="space-y-1.5 text-sm text-white/70">
                  {it.perks.map((p, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#FFBF00] mt-2 shrink-0" />{p}
                    </li>
                  ))}
                </ul>
                <div className="flex items-center justify-between mt-5">
                  <div className="font-hero text-3xl text-[#FFBF00]">₹{it.price_inr}</div>
                  <button
                    data-testid={`store-buy-${it.id}`}
                    onClick={() => { sfx.pling(); toast.info("Redirecting to checkout...", { description: `${it.name} · ₹${it.price_inr}` }); }}
                    className="px-4 py-2 rounded-full bg-[#FFBF00] hover:bg-[#FF8C00] text-black font-semibold text-xs uppercase tracking-wider transition-colors"
                  >
                    Purchase
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
